import { TextField, InputAdornment } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Rich Text Editor Widget - simplified to just multiline text without markdown
export const RichTextWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, placeholder, options, schema } = props;
  const minRows = (options?.rows as number) || 4;

  return (
    <TextField
      id={id}
      value={value ?? ""}
      onChange={(event) => onChange(event.target.value || undefined)}
      disabled={disabled}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: schema.description ? (
            <InputAdornment position="end">
              {renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ) : null,
        },
      }}
      placeholder={placeholder}
      label={renderLabel(label, !!required)}
      required={required}
      multiline
      minRows={minRows}
      maxRows={12}
      fullWidth
      variant="outlined"
      sx={inputStyles}
    />
  );
};
